import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Link, Redirect} from 'react-router-dom';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class PaymentValuesEdit extends Component {

  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      types_select: [
        { value: 'national', label: this.locale.ValoresDePagamento.EditarValoresDeDiarias.opcoesTipo.DiariaNacional },
        { value: 'international', label: this.locale.ValoresDePagamento.EditarValoresDeDiarias.opcoesTipo.DiariaInternacional },
        { value: 'europe', label: this.locale.ValoresDePagamento.EditarValoresDeDiarias.opcoesTipo.DiariaEuropa },
        { value: 'transport', label: this.locale.ValoresDePagamento.EditarValoresDeDiarias.opcoesTipo.IndenizacaoTransporte },
        { value: 'deslocation', label: this.locale.ValoresDePagamento.EditarValoresDeDiarias.opcoesTipo.IndenizacaoDeslocamento },
        { value: 'base_chief', label:  this.locale.ValoresDePagamento.EditarValoresDeDiarias.opcoesTipo.IndenizacaoRepresentanteOperacional},
        { value: 'gratification', label: this.locale.ValoresDePagamento.EditarValoresDeDiarias.opcoesTipo.IndenizacaoGratificacaoDeCheque},
      ],
      currencies_select: [
        { value: 'BRL', label: 'BRL' },
        { value: 'USD', label: 'USD' },
        { value: 'EUR', label: 'EUR' },
      ],
      roles_select: '',
      companies_select: '',
      value: '',
      data: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamento/valores';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/pagamento/valores');
        if (responseJson.status === 'success') {
          self.setState({
            data: responseJson.data.main,
            roles_select: responseJson.data.roles_select,
            companies_select: responseJson.data.companies_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      type: this.state.type,
      role_id: this.state.role_id,
      value: this.state.value,
      currency: this.state.currency,
      company_id: this.state.company_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/valores', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ data: responseJson.data });
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete(datasave) {
    if (window.confirm(this.locale.ValoresDePagamento.EditarValoresDeDiarias.deletar)) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/pagamento/valores', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({ data: responseJson.data });
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ValoresDePagamento.EditarValoresDeDiarias.titulo}</h3>
      <Link to="/pagamentos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <div>
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.formulario.Tipo}:</label>
              <Select
                className=""
                name="type"
                value={this.state.type}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={this.state.types_select}
                required
              />
            </div>
            <div className="col-md-6 form-group">
              <label>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.formulario.Cargo}:</label>
              <Select
                className=""
                name="role_id"
                value={this.state.role_id}
                searchable={true}
                placeholder={''}
                multi={true}
                onChange={this.handleSelectChangeMultiple.bind(this, 'role_id')}
                options={this.state.roles_select}
              />
            </div>
          </div>
          <div className="row">

            <div className="col-md-4 form-group">
              <label>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.formulario.Moeda}:</label>
              <Select
                className=""
                name="currency"
                value={this.state.currency}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'currency')}
                options={this.state.currencies_select}
                required
              />
            </div>
            <div className="col-md-4 form-group">
              <label>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.formulario.Empresa}:</label>
              <Select
                className=""
                name="company_id"
                value={this.state.company_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'company_id')}
                options={this.state.companies_select}
                required
              />
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.formulario.Valor}:</label>
                <input value={this.state.value} name="value" className="form-control" onChange={this.handleChange.bind(this, 'value')} placeholder="999,99" />
              </div>
            </div>
          </div>
          <hr/>
          <div>
            <button type="submit" className="btn btn-primary btn-lg btn-block" required><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
          </div>
        </form>
        <hr/>
        <h4 className="page-title">{this.locale.ValoresDePagamento.EditarValoresDeDiarias.tituloValoresCadastrados}</h4>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.tabela.Tipo}</th>
                <th>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.tabela.Empresa}</th>
                <th>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.tabela.Moeda}</th>
                <th>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.tabela.Valor}</th>
                <th>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.tabela.Cargos}</th>
                <th>{this.locale.ValoresDePagamento.EditarValoresDeDiarias.tabela.Acoes}</th>
              </tr>
            </thead>
            <tbody>
            {Object.keys(self.state.data).map(function(k) {
              var pv = self.state.data[k];
              return (
                <tr>
                  <td>{pv.type_str}</td>
                  <td>{pv.company}</td>
                  <td>{pv.currency}</td>
                  <td>{pv.value_str}</td>
                  <td>{pv.roles}</td>
                  <td className="text-center">
                    <button onClick={() => self.delete({type: pv.type, currency: pv.currency, company_id: pv.company_id, role_ids: pv.role_ids})} className="btn btn-danger btn-sm"><i className="fa fa-trash"></i></button>
                  </td>
                </tr>
              );
            })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentValuesEdit;



// WEBPACK FOOTER //
// ./src/Components/PaymentValues/PaymentValuesEdit.js